import { computed, inject, Injectable } from '@angular/core';
import { AdminDto, AdminAdminService } from '@api-client';
import { AuthTokenService, BaseStore } from '@client-libs';
import { toObservableSignal } from 'ngxtension/to-observable-signal';
import { lastValueFrom } from 'rxjs';

type State = {
  admin: AdminDto | null;
};

/**
 * 관리자 계정 정보를 관리하는 스토어입니다.
 */
@Injectable({ providedIn: 'root' })
export class AdminStore extends BaseStore<State> {
  private readonly adminService = inject(AdminAdminService);
  private readonly authTokenService = inject(AuthTokenService);

  admin = toObservableSignal(computed(() => this.state()?.admin));

  constructor() {
    super({
      admin: null,
    });
  }

  /**
   * 현재 로그인한 관리자 정보를 서버에서 가져옵니다.
   */
  async fetch() {
    const admin = await lastValueFrom(
      this.adminService.adminAdminControllerFindMeV1()
    );

    this.set(admin);
  }

  /**
   * 서버 세션 및 로컬 토큰을 삭제하여 로그아웃 처리합니다.
   */
  async logout() {
    await lastValueFrom(this.adminService.adminAdminControllerSignOutV1());
    this.authTokenService.clearTokens();
  }

  /**
   * 상태에 관리자 정보를 저장합니다.
   */
  set(admin: AdminDto) {
    this.updateState({ admin });
  }

  /**
   * 관리자 정보를 초기화합니다.
   */
  clear() {
    this.updateState({ admin: null });
  }
}
